'use client';

import { usePathname } from 'next/navigation';

import { useAgentContext } from '@libs/common-next';

export function ChatbotContext() {
    useAgentContext({ description: 'Current page path', value: usePathname() });

    return null;
}
